<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">

        <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
          <!-- <a-col class="a-large-form">
            <a-form-item
              style="margin-bottom:0px"
              label=""
              :required="false"
            >
              <j-dict-select-tag v-model="queryParam.categoryId" placeholder="栏目" dictCode="information_type" />
            </a-form-item>
          </a-col> -->
          <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <j-input placeholder="请输入标题" v-model="queryParam.title"></j-input>
            </a-form-item>
          </a-col>
          <!-- <a-col class="a-large-form">
              <a-form-item label="" style="margin-bottom:0px">
                <a-input placeholder="请输入学员名称" v-model="queryParam.realName"></a-input>
              </a-form-item>
            </a-col> -->

          <a-button type="primary" @click="searchQuery" icon="search" style="margin-right:10px;margin-left:5px;">查询</a-button>
          <a-button type="primary" @click="createInfo" icon="plus" style="float:right;margin-left:5px" >新增</a-button>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('资讯')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="newOffShelf(record.id)" v-if="record.isDisplay">下架</a>
          <a @click="newOnShelf(record.id)" v-else>上架</a>
          <a-divider type="vertical" />
          <a @click="toEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="toComment(record)">查看评论</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>

          <!-- <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>

      </a-table>
    </div>
    <!-- <elinkx-cms-information-modal ref="modalForm" @ok="modalFormOk"></elinkx-cms-information-modal> -->
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
 
  // import ElinkxCmsInformationModal from './modules/ElinkxCmsInformationModal'
  import JSuperQuery from '@/components/jeecg/JSuperQuery.vue'

  import { newsOnShelf, newsOffShelf } from '@/api/api'

  export default {
    name: 'ElinkxCmsInformationList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      // ElinkxCmsInformationModal,
      JSuperQuery
    },
    data () {
      return {
        description: '资讯管理页面',
        // 表头
        columns: [
          {
            title: '标题',
            align: 'center',
            dataIndex: 'title',
            width: 260
          },
          {
            title: '状态',
            align: 'center',
            dataIndex: 'isDisplay_dictText',
            customRender: function (text, record) {
              if (text) {
                return text
              } else {
                return '待上架'
              }
            }
          },
          {
            title: '更新人',
            align: 'center',
            dataIndex: 'updateBy_dictText',
            customRender: function (text, record) {
              if (record.updateBy_dictText) {
                return record.updateBy_dictText
              } else {
                return record.createBy_dictText
              }
            }
          },
          {
            title: '更新时间',
            align: 'center',
            dataIndex: 'updateTime',
            customRender: function (text, record) {
              if (text) {
                return text
              } else {
                return record.createTime
              }
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/cms/elinkxCmsInformation/list',
          delete: '/cms/elinkxCmsInformation/delete',
          deleteBatch: '/cms/elinkxCmsInformation/deleteBatch'
          // exportXlsUrl: "/cms/elinkxCmsInformation/exportXls",
          // importExcelUrl: "cms/elinkxCmsInformation/importExcel",

        },
        dictOptions: {},
        superFieldList: []
      }
    },
    created() {
    this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function() {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      toEdit (record) {
        this.$router.push({ path: '/information/createInfo?id=' + record.id })
      },
      toComment(record){
        this.$router.push({ path:'/information/InformationRatingManage?id='+record.id});
      },
      createInfo () {
        this.$router.push({ path: '/information/createInfo' })
      },
      initDictConfig() {
      },
      getSuperFieldList() {
        let fieldList = []
        fieldList.push({ type: 'select', value: 'categorId', text: '栏目', dictCode: 'information_type' })
        fieldList.push({ type: 'string', value: 'tag', text: '标签关键字', dictCode: '' })
        fieldList.push({ type: 'string', value: 'title', text: '标题', dictCode: '' })
        // fieldList.push({type:'string',value:'picList',text:'缩略图list',dictCode:''})
        fieldList.push({ type: 'string', value: 'description', text: '摘要', dictCode: '' })
        // fieldList.push({type:'string',value:'outUrl',text:'外部链接',dictCode:''})
        // fieldList.push({type:'string',value:'type',text:'类型',dictCode:''})
        fieldList.push({ type: 'Text', value: 'content', text: '正文', dictCode: '' })
        fieldList.push({ type: 'string', value: 'source', text: '文章来源', dictCode: '' })
        // fieldList.push({type:'string',value:'author',text:'文章作者',dictCode:''})
        // fieldList.push({type:'int',value:'isOriginal',text:'是否原创',dictCode:''})
        // fieldList.push({type:'int',value:'isDisplay',text:'是否显示',dictCode:''})
        // fieldList.push({type:'int',value:'isTop',text:'是否置顶',dictCode:''})
        // fieldList.push({type:'int',value:'isRecommend',text:'发布时间',dictCode:''})
        // fieldList.push({type:'int',value:'sort',text:'自定义顺序',dictCode:''})
        // fieldList.push({type:'int',value:'hit',text:'点击次数',dictCode:''})
        // fieldList.push({type:'int',value:'star',text:'点赞次数',dictCode:''})
        // fieldList.push({type:'date',value:'publishDate',text:'发布时间'})
        fieldList.push({ type: 'string', value: 'publishName', text: '发布者名', dictCode: '' })
        fieldList.push({ type: 'string', value: 'publishAvatar', text: '发布者头像', dictCode: '' })
        // fieldList.push({type:'string',value:'createBy',text:'创建人ID',dictCode:''})
        // fieldList.push({type:'date',value:'createTime',text:'创建时间'})
        // fieldList.push({type:'string',value:'updateBy',text:'修改人ID',dictCode:''})
        // fieldList.push({type:'date',value:'updateTime',text:'修改时间'})
        // fieldList.push({type:'int',value:'delFlag',text:'删除标识0-正常,1-已删除',dictCode:''})
        // fieldList.push({type:'string',value:'sysSign',text:'Saas码',dictCode:''})
        this.superFieldList = fieldList
      },
      newOffShelf(id) {
        newsOffShelf({ id: id }).then((res) => {
          if (res.success) {
            console.log(res)
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      },
      newOnShelf(id) {
        newsOnShelf({ id: id }).then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
